<template>
  <div id="home">
    <!-- 栏目轮播图 -->
    <div class="defaultBox">
      <img src="@/assets/images/bs/banner.jpg" />
    </div>

    <!-- 法律法规 -->
    <div class="Learning-education">
      <div class="title01">
        <p>法律法规</p>

        <div class="autoBox">
          <ul class="timeline">
            <li
              v-for="item in flfgList.slice(0, dataBannerSize)"
              :key="item.name"
              @click="detailContent(item)"
            >
              <span>{{ item.displayDate.substring(0, 10) }}</span>
              <p>
                <a href="#" target="_blank" title="">{{ item.title }}</a>
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div class="emptyMessage" v-if="flfgList.length == 0">暂无数据~</div>
      <div v-if="flfgList.length > dataBannerSize" class="more dtMore">
        <a @click="moreMethod(flfgChannelId)">更多</a>
      </div>
    </div>

    <!-- 工作动态 -->
    <div class="Learning-education001">
      <div class="title01">
        <p>工作动态</p>
      </div>

      <div class="classroom-box classroom-box-sj">
        <ul class="info-list">
          <li
            class="img-li"
            v-for="item in gzdtList.slice(0, dataBannerSize)"
            :key="item.name"
            @click="detailContent(item)"
          >
            <div href="##" target="_blank" class="education001-href-auto">
              <div class="label-div">
                <h3 class="title">
                  {{ item.title }}
                </h3>
                <p class="education001-p-auto">
                  {{ item.displayDate.substring(0, 10) }}
                </p>
              </div>
              <div class="photo-div">
                <img
                  v-if="item.displayResourcesLenth != 0"
                  :src="item.displayResources[0].sourceUrl"
                  alt=""
                />
              </div>
            </div>
          </li>
        </ul>
      </div>

      <!-- 切换 -->
      <div class="classroom-box-qzbs">
        <ul class="classroom-list-qzbs">
          <li
            v-for="item in gzdtList.slice(0, dataBannerSize)"
            :key="item.name"
            @click="detailContent(item)"
          >
            <div class="xcwlBox-qzbs">
              <img
                v-if="item.displayResourcesLenth != 0"
                :src="item.displayResources[0].thumbUrl"
                alt=""
                class="pic-img-qzbs"
              />
            </div>
            <h3 class="title-qzbs">
              {{ item.title }}
            </h3>
          </li>
          <li class="last-li">
            <div
              v-if="gzdtList.length > dataBannerSize"
              class="last-li-more xcwMore"
              @click="moreMethod(gzdtChannelId)"
            ></div>
          </li>
        </ul>
      </div>

      <div class="emptyMessage" v-if="gzdtList.length == 0">暂无数据~</div>
      <div v-if="gzdtList.length > dataBannerSize" class="more">
        <a @click="moreMethod(gzdtChannelId)">更多</a>
      </div>
    </div>
  </div>
</template>

<script>
import { share } from "@/common/utils";

export default {
  name: "",
  data() {
    return {
      loading: false,
      finished: false,
      pageNo: 1,
      bannerSize: 3,
      dataBannerSize: 3,

      flfgChannelId: "178f3432f5e848e6882a428baea9d5b5", //法律法规
      gzdtChannelId: "6f56ad025e5a4513a2b64eb66652431a", //工作动态
      flfgList: [], // 法律法规
      gzdtList: [] // 工作动态
    };
  },
  components: {},
  mounted() {
    const info = {
      title: "人大换届选举", //标题
      summary: "更多精彩内容，下载宝山汇App", //简介
      link: window.location.href, //链接地址
      imageUrl: "https://assets.shmedia.tech/icon/bs.png"
    };
    share(info);
    // 初始化数据
    this.getData(this.flfgChannelId, "flfgType");
    this.getData(this.gzdtChannelId, "gzdtType");
  },
  methods: {
    getData(channelId, channelType) {
      this.$http.post("/app/news/content/list", {
        data: {
          pageNo: this.pageNo,
          pageSize: "20",
          channel: { id: channelId },
          orderBy: "release_desc"
        },
        success: data => {
          if (data.records.length) {
            for (let t of data.records) {
              if (t.displayResources.length > 0) {
                t.displayResourcesLenth = 1;
              } else {
                t.displayResourcesLenth = 0;
              }

              let types = t.displayStyle;
              if (types === "plain-text") {
                // 无图
                t.style = "small";
              }
              if (types === "inline-image") {
                // 小图
                t.style = "small";
              }
              if (types === "image") {
                // 大图
                t.style = "bigpic";
              }
              if (types === "v-image") {
                // 1张竖图
                t.style = "small";
              }
              if (types === "multi-image") {
                // 多张横图
                t.style = "bigpic";
              }
              if (types == "video") {
                //视频
                t.style = "video";
              }

              if (channelType === "flfgType") {
                this.flfgList.push(t);
              } else if (channelType === "gzdtType") {
                this.gzdtList.push(t);
              }
            }
            this.pageNo++;
          } else {
            this.finished = true;
          }
          this.loading = false;
        }
      });
    },
    detailContent(item) {
      const agent = window.navigator.userAgent.toLowerCase();
      const isRmt = -1 != agent.indexOf("rmt"); //RMT
      if (isRmt) {
        rmt.openAction({
          actionUrl: item.actionUrl, //链接地址
          closing: false //打开链接后，是否关闭本页面
        });
      } else {
        location.href = item.shareUrl;
      }
    },
    // 跳转更多列表页
    moreMethod(channelId) {
      this.$router.push({
        path: "/bsList",
        query: {
          channelId: channelId
        }
      });
    }
  }
};
</script>

<style scope>
@import "../assets/bsHome.css";
</style>
